(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lbl-detail-swatch"] && !Shopify.designMode) return;
  try {
    (function(){
  if (window.__lblSwInit) return; window.__lblSwInit = true;
  document.addEventListener('click', function(e){
    var t = e.target.closest('.lblsw-tile'); if (!t) return;
    var card = t.closest('.cgrid-card') || t.closest('[data-dl-card]') || t.closest('.dl-v7-product'); if (!card) return;
    var matl = card.querySelector('.cgrid-matl');
    if (matl && t.getAttribute('data-matl')) matl.textContent = t.getAttribute('data-matl');
    card.querySelectorAll('.lblsw-tile').forEach(function(x){ x.setAttribute('aria-pressed', x === t ? 'true' : 'false'); x.classList.toggle('is-active', x === t); });
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lbl-pdp-variants"] && !Shopify.designMode) return;
  try {
    (function(){
  if (window.__lblPdpInit) return; window.__lblPdpInit = true;
  document.addEventListener('click', function(e){
    var t = e.target.closest('[data-lbl-pdp] .lblsw-tile'); if (!t) return;
    e.preventDefault();
    if (t.classList.contains('is-active')) return;
    var url = t.getAttribute('data-url'); if (url) window.location.href = url;
  });
  document.addEventListener('mouseover', function(e){
    var t = e.target.closest('[data-lbl-pdp] .lblsw-tile'); if (!t) return;
    var lbl = t.closest('[data-lbl-pdp]').querySelector('[data-lbl-colour]');
    if (lbl && t.getAttribute('data-colour')) { lbl.textContent = t.getAttribute('data-colour').replace(/^./, function(c){ return c.toUpperCase(); }); }
  });
  document.addEventListener('mouseout', function(e){
    var t = e.target.closest('[data-lbl-pdp] .lblsw-tile'); if (!t) return;
    var wrap = t.closest('[data-lbl-pdp]'); var act = wrap.querySelector('.lblsw-tile.is-active'); var lbl = wrap.querySelector('[data-lbl-colour]');
    if (lbl && act) { lbl.textContent = act.getAttribute('data-colour').replace(/^./, function(c){ return c.toUpperCase(); }); }
  });
})();
  } catch(e) { console.error(e); }
})();

})();
